module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_3.46b21c98.png";